// Vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form as FinalForm, Field } from 'react-final-form';
import cn from 'classnames';
// Root Styles
import '../../styles/document.styl';
// Styles
import './style.styl';

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.input.value,
      isOpen: false,
    };
  }

  componentDidMount = () => {
    const selectWrapper = this.refs.wrapper;
    const selectArea = this.refs.select;
    const optionsList = this.refs.options;

    // .offsetWidth
    let max = 0;
    for (let key in this.refs) {
      if (key.indexOf('option_') > -1) {
        max = Math.max(max, this.refs[key].offsetWidth);
      }
    }
    selectArea.style.minWidth = max + 'px';

    document.addEventListener('click', event => {
      const isClickInside = selectWrapper.contains(event.target);
      if (!isClickInside) {
        this.handleClose();
      }
    });
  };

  handleToggle = () => {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen,
    });
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  handleChange = value => {
    const { onChange } = this.props.input;
    this.setState({
      value: value,
    });
    this.handleClose();
    if (onChange) onChange(value);
  };

  render() {
    const { name, options, className, placeholder, alt, light, wide } = this.props;
    const { value, isOpen } = this.state;

    const blockWrapperClass = cn({
      Select: true,
      [`${className}`]: className,
    });

    const blockSelectClass = cn({
      Select__select: true,
      Select__select_light: light,
      Select__select_wide: wide,
      Select__select_alt: alt,
      Select__select_opened: isOpen,
      [`${className}`]: className,
    });

    const blockOptionsClass = cn({
      Select__options: true,
      Select__options_opened: isOpen,
    });

    const selectedOption =
      options && options.find(x => x.id === value) && options.find(x => x.id === value).title;

    return (
      <div className={blockWrapperClass} ref="wrapper">
        <div className={blockSelectClass} onClick={this.handleToggle} ref="select">
          {selectedOption}
        </div>
        <div className="Select__options-wrapper">
          <div className={blockOptionsClass} ref="options">
            {options &&
              options.map((item, index) => {
                if (value !== item.id) {
                  return (
                    <div
                      key={item.id}
                      ref={`option_${item.id}`}
                      className="Select__option"
                      onClick={() => {
                        this.handleChange(item.id);
                      }}>
                      {item.title}
                    </div>
                  );
                }
              })}
          </div>
        </div>
      </div>
    );

    // return (
    //   <Field className={blockWrapperClass} name={name} value={value} component="select">
    //     {placeholder && (
    //       <option value="" className="Select__option Select__option_placeholder">
    //         {placeholder}
    //       </option>
    //     )}
    //     {options &&
    //       options.map((item, index) => {
    //         return (
    //           <option key={item.id} value={item.id} className="Select__option">
    //             {item.title}
    //           </option>
    //         );
    //       })}
    //   </Field>
    // );
  }
}

Select.defaultProps = {
  className: '',
};

Select.propTypes = {
  className: PropTypes.string,
};

export default Select;



// WEBPACK FOOTER //
// components/Select/index.js